exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._21pKgejvDjP4a3Pphmy6BA{background-color:#454579;color:#fff}", ""]);

// exports
exports.locals = {
	"main": "_21pKgejvDjP4a3Pphmy6BA"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules!./~/sass-loader!./src/containers/CoreLayout.scss
 ** module id = 308
 ** module chunks = 0
 **/